import {
    getProductFeature,
    listProductFeatures
} from './queries';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    CreateProductFeature,
    DeleteProductFeature,
    GetProductFeature,
    ListProductFeatures,
    ProductFeature,
    UpdateProductFeature,
    EnableProductFeature,
    DisableProductFeature
} from "../types.ts";
import { billingApiClient } from "../../billing-api-integration";
import {
    createProductFeature,
    deleteProductFeature,
    updateProductFeature,
    enableProductFeature,
    disableProductFeature
} from "./mutations.ts";
import {ListRecordsQuery} from "../../../types";


const client = billingApiClient;


const normalizeFilter = (filter: { [key: string]: string }) =>
    Object.keys(filter).reduce((acc: { [key: string]: string }, key) => {
        if (filter[key] !== '' && filter[key] !== undefined) {
            acc[key] = filter[key];
        }
        return acc;
    }, {});

export const fetchRecords = async (query: ListRecordsQuery) => {
    const { filter, ...rest } = query;
    const transformedFilter = filter ? normalizeFilter(filter as { [key: string]: string }) : {};

    const response = await client.graphql<GraphQLQuery<ListProductFeatures>>({
                                                                                 query: listProductFeatures,
                                                                                 variables: {
                                                                                     ...rest,
                                                                                     ...(Object.keys(transformedFilter).length ? { filter: transformedFilter } : {})
                                                                                 },
                                                                             });
    return {
        items: response.data?.listProductFeatures.items,
        nextToken: response.data?.listProductFeatures.nextToken
    };
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetProductFeature>>({
                                                                               query: getProductFeature,
                                                                               variables: {id: id},
                                                                           });
    return response.data?.getProductFeature;
};

// Inputs are WHITELISTED to the API input types (see types.ts). Naming the fields sent
// means a field the form happens to carry, such as the add drawer's empty `id`, can never
// reach AppSync, which rejects the whole call for one undeclared field (FNP-1897).
export const buildCreateProductFeatureInput = (values: Omit<ProductFeature, 'id'>) => ({
    name: values.name,
    description: values.description,
    category: values.category,
    // Required by CreateProductFeatureInput. New features start as Draft: the add drawer
    // seeds it, and nothing on the add form changes it (lead decision on FNP-1897).
    status: values.status ?? 'Draft',
});

export const buildUpdateProductFeatureInput = (id: string, values: ProductFeature) => ({
    id,
    name: values.name,
    description: values.description,
    category: values.category,
    status: values.status,
});

export const add = async (payload: Omit<ProductFeature, 'id'>) => {
    const response = await client.graphql<GraphQLQuery<CreateProductFeature>>({
                                                                                  query: createProductFeature,
                                                                                  variables: {input: buildCreateProductFeatureInput(payload)},
                                                                              });
    return response.data?.createProductFeature;
};

export const update = async (id: string, record: ProductFeature) => {
    const response = await client.graphql<GraphQLQuery<UpdateProductFeature>>({
                                                                                  query: (updateProductFeature),
                                                                                  variables: {input: buildUpdateProductFeatureInput(id, record)},
                                                                              });
    return response.data?.updateProductFeature;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteProductFeature>>({
                                                                                  query: (deleteProductFeature),
                                                                                  variables: {input: {id: id}},

                                                                              });
    return response.data?.deleteProductFeature;
};

export const enableRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<EnableProductFeature>>({
        query: enableProductFeature,
        variables: { id }
    });
    return response.data?.activateProductFeature;
};

export const disableRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DisableProductFeature>>({
        query: disableProductFeature,
        variables: { id }
    });
    return response.data?.cancelProductFeature;
};
